import React, { forwardRef } from "react";
import { Button, Input, Space } from "antd";
import { normalizeWhatsAppPhoneInput } from "../utils/whatsappPhone";

const WhatsAppPhoneInput = forwardRef(function WhatsAppPhoneInput(
  { value, onChange, phone, disabled, ...inputProps },
  ref,
) {
  return (
    <Space direction="vertical" size={4} style={{ width: "100%" }}>
      <Input
        {...inputProps}
        ref={ref}
        autoComplete="off"
        disabled={disabled}
        inputMode="tel"
        maxLength={40}
        onChange={(event) => onChange?.(event.target.value)}
        placeholder="Ex. +226 70 00 00 00"
        value={value || ""}
      />
      <Button
        disabled={disabled || !String(phone || "").trim()}
        htmlType="button"
        onClick={() => onChange?.(normalizeWhatsAppPhoneInput(phone))}
        size="small"
        style={{ height: "auto", padding: 0, whiteSpace: "normal", textAlign: "left" }}
        type="link"
      >
        Utiliser le téléphone existant
      </Button>
    </Space>
  );
});

export default WhatsAppPhoneInput;
